import React, { useState } from 'react';
import {
  Accordion,
  AccordionContent,
  AccordionPanel,
} from '@americanexpress/dls-react';
import { useIntl } from 'react-intl';
import { useMediaBreakpoint } from '@americanexpress/consumer-travel-base';
import clsx from 'clsx';
import { OnVisible } from '@americanexpress/data-manager-utils';
import { useReactlytics } from '@americanexpress/reactlytics';
import style from '../AbandonHotel.scss';
import { useAbandonCartData } from '../../../hooks/useContextApiHook';
import AbandonHotelIcon from '../AbandonHotelIcon';
import { formatDate } from '../../../utils/abandonCartUtils';
import { createAnalytics } from '../../../utils/createAnalyticsUtil';
import ContinueButton from '../ContiueButton/ContinueButton';
import DismissButton from '../DismissButton/DimissButton';

const AbandonHotelMobile = () => {
  const { formatMessage } = useIntl();
  const isMobile = useMediaBreakpoint('sm-down');
  const [collapsibleOpen, setCollapsibleOpen] = useState(false);
  const { track } = useReactlytics();
  const triggerAnalytics = (detail) => {
    switch (detail) {
      case 'continue':
      case 'dismiss':
        createAnalytics(track, { element: 'hp-mobile-AbandonHotel', type: 'click' })(detail);
        break;
      default:
        if (!collapsibleOpen) {
          setCollapsibleOpen(true);
          createAnalytics(track, { element: 'hp-mobile-AbandonHotel', type: 'click' })(detail);
        } else { setCollapsibleOpen(false); }
        break;
    }
  };

  const {
    data: abandonCartData,
  } = useAbandonCartData();
  const {
    tripStartDate,
    tripEndDate,
    hotelProductSelected,
  } = abandonCartData;

  const accordionId = 'hotelBannerMobilePanel';

  return (
    <div id="abandonHotelMobile" className={clsx('pad-1-b position-relative', !isMobile && 'container')}>
      <OnVisible analyticsInfo={{
        element: 'hp-mobile-AbandonHotel',
        detail: null,
      }}
      >
        <Accordion
          id="hotelBannerMobile"
          className="dls-deep-blue-bg"
          onClick={(event) => {
            event.stopPropagation();
            triggerAnalytics('mobileOpen');
          }}
        >
          <AccordionPanel
            aria-label={formatMessage({ id: 'abandonHotel.finish' })}
            data-testid={accordionId}
            id={accordionId}
            className={clsx('pad-2-tb flex flex-align-items-center', style.collapseCaret)}
          >
            <div className="flex-inline dls-white flex flex-align-items-center">
              <AbandonHotelIcon />
              <div className="heading-2">
                {formatMessage({ id: 'abandonHotel.finish' })}
              </div>
            </div>
          </AccordionPanel>
          <AccordionContent aria-labelledby={accordionId}>
            <div
              className="dls-deep-blue-bg pad-1 dls-white"
              style={{ borderTop: '1px solid white' }}
            >
              <div className="text-align-center">
                <span>
                  {formatMessage({ id: 'abandonHotel.finish' })}
                </span>
                <span>
                  {formatMessage({ id: 'abandonHotel.at' })}
                </span>
                <span className="font-weight-bold text-capitalize">
                  {hotelProductSelected.toLowerCase()}
                </span>
                <span className="text-nowrap">
                  {formatMessage({ id: 'abandonHotel.for' })}
                  <span className="font-weight-bold text-nowrap">
                    {`${formatDate(tripStartDate)} - ${formatDate(tripEndDate)}`}
                  </span>
                </span>
              </div>
              <div className="pad-1 row flex flex-justify-center">
                <div className="flex flex-justify-center">
                  <ContinueButton
                    triggerAnalytics={triggerAnalytics}
                    buttonTextLocaleId="abandonHotel.continueMobile"
                  />
                </div>
                <div className="flex flex-justify-center">
                  <DismissButton
                    triggerAnalytics={triggerAnalytics}
                  />
                </div>
              </div>
            </div>
          </AccordionContent>
        </Accordion>
      </OnVisible>
    </div>
  );
};

export default AbandonHotelMobile;
